// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
import {Icon} from '@wandb/weave/components/Icon';
import React, {FC} from 'react';

import {Analytics} from '../../../../services/analytics';
import {useSemanticLegendSettingsContext} from './SemanticLegendSettingsWithCategoricalConfigContextProvider';
import {invertColorsWithCategoricalConfig} from './utils/invertColors';
import {resetColors} from './utils/resetColors';
import {useGetWorkspaceSettingsSemanticLegendPaletteWithCategoricalConfig} from './utils/useGetWorkspaceSettingsSemanticLegendPaletteWithCategoricalConfig';

interface SemanticLegendBucketsActionsProps {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isOpen: boolean;
}

export const SemanticLegendBucketsActionsWithCategoricalConfig: FC<
  SemanticLegendBucketsActionsProps
> = ({setIsOpen, isOpen}) => {
  const {semanticLegendSettings, updateSemanticLegendSettings} =
    useSemanticLegendSettingsContext();
  const getSemanticLegendPalette =
    useGetWorkspaceSettingsSemanticLegendPaletteWithCategoricalConfig();

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <DropdownMenu.Root open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenu.Trigger>
        <Button
          active={isOpen}
          data-test="buckets-actions-overflow"
          icon="overflow-horizontal"
          variant="ghost"
          aria-label="More actions"
          size={'small'}
        />
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content align="center">
          <DropdownMenu.Item
            data-test="invert-colors-button"
            onClick={() => {
              Analytics.track('Semantic legend invert colors', {
                newValue: semanticLegendSettings.yAxisValue,
              });
              updateSemanticLegendSettings?.(
                invertColorsWithCategoricalConfig(
                  semanticLegendSettings,
                  getSemanticLegendPalette(semanticLegendSettings.yAxisValue)
                )
              );
              handleClose();
            }}>
            <Icon name="swap" /> Invert colors
          </DropdownMenu.Item>
          <DropdownMenu.Item
            data-test="reset-colors-button"
            onClick={() => {
              Analytics.track('Semantic legend reset colors', {
                newValue: semanticLegendSettings.yAxisValue,
              });
              updateSemanticLegendSettings?.(
                resetColors(semanticLegendSettings ?? {})
              );
              handleClose();
            }}>
            <Icon name="reload-refresh" /> Reset colors
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};
